import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import language from './../components/language'

const getTranslation = (locale, json) => {
    return Object.keys(json).reduce((result, mapItem) => {
        let content = {

        };
        if (json?.[mapItem]?.children) {
            const translation = getTranslation(locale, json?.[mapItem]?.children)
            content = {
                ...translation,
                [""]: json?.[mapItem]?.[locale]
            }
        } else {
            content = json?.[mapItem]?.[locale]
        }
        return {
            ...result,
            [mapItem]: content,
        }
    }, {})
}
i18n
    .use(initReactI18next)
    .init({
        fallbackLng: 'en', // 當沒有對應翻譯時，使用的後備語言
        lng: 'zh-TW', // 預設語言設為 'zh-TW'
        resources: {
            en: {
                translation: getTranslation('en', language)
            },
            'zh-TW': {
                translation: getTranslation('zh-tw', language)
            },
        },
        react: {
            useSuspense: false
        }
    });
export default i18n;
